import { GetIssueResponseDtoSeverityEnum } from '@issuemanager/api-client';
import { Chip } from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { useIssueSeverities } from '@issuemanager/client/features/issues';
import { type SxProps } from '@mui/material';
import { type JSX } from 'react';

type SeverityChipProps = {
  severity: GetIssueResponseDtoSeverityEnum | null;
};

export function IssueSeverityChip({
  severity,
}: SeverityChipProps): JSX.Element | null {
  const semantic = useAtlasSemanticThemeTokens();

  const issueSeverities = useIssueSeverities();
  const issueSeverity = issueSeverities.find(
    (issueStatus) => issueStatus.value === severity,
  );

  const commonStyle: SxProps = {
    fontWeight: semantic.fontWeight.emphasis.value,
    backgroundColor: issueSeverity?.backgroundColor,
    color: issueSeverity?.color,
    borderRadius: 1,
    padding: semantic.spacing.default.value,
    letterSpacing: '1px',
  };

  if (severity === undefined) {
    return null;
  }

  return (
    <Chip
      data-testid='severity-chip'
      sx={commonStyle}
      label={issueSeverity?.label}
      title={severity ?? 'null'}
    />
  );
}
